<template>
    <div class="w-full bg-gray-200 rounded-full h-1 overflow-hidden">
        <div class="bg-blue-500 h-1 text-center text-xs text-white transition-width duration-300 ease-in-out"
            :style="{ width: progress + '%' }"></div>
    </div>
</template>

<script>
export default {
    props: {
        progress: {
            type: Number,
            required: true
        }
    }
};
</script>

<style scoped>
/* You can add custom styles here if needed */
</style>